import {
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  Pressable,
} from "react-native";
import React, { useState } from "react";
import AppImages from "../../../Constants/AppImages";
import AppColors from "../../../Constants/AppColors";
import AppFonts from "../../../Constants/AppFonts";
import { Holiday, ModalDel } from "../../../Constants/Data";
import Appstyles from "../../../Constants/AppStyles";

const Holidays = ({ navigation }) => {
  const [DotModal, setDotModal] = useState(false);
  const [Modalvisible1, setModalvisible1] = useState(false);
  const [selectedButton, setSelectedButton] = useState(1);
  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };

  const Holiday = [
    {
      id: 1,
      Day: "01",
      Month: "Jan",
      NewYear: "New Year",
      Friday: "Friday",
      Active: "Active",
      img: AppImages.Threedots,
    },
    {
      id: 2,
      Day: "01",
      Month: "Mar",
      NewYear: "New Year",
      Friday: "Friday",
      Active: "Active",
    },
    {
      id: 3,
      Day: "01",
      Month: "Sept",
      NewYear: "New Year",
      Friday: "Friday",
      Active: "Active",
    },
    {
      id: 4,
      Day: "01",
      Month: "Jan",
      NewYear: "New Year",
      Friday: "Friday",
      Active: "Active",
    },
    {
      id: 5,
      Day: "01",
      Month: "Jan",
      NewYear: "New Year",
      Friday: "Friday",
      Active: "Active",
    },
    {
      id: 6,
      Day: "01",
      Month: "Jan",
      NewYear: "New Year",
      Friday: "Friday",
      Active: "Active",
    },
  ];
  //---------Search Text Input---------//
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(Holiday);
  const [searchText, setSearchText] = useState(""); // State for search input

  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = Holiday.filter((item) =>
      item.NewYear.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  //-------Del FlatList ---------//
  const handleThreeDotPress = (item) => {
    setSelectedItem(item);
    setDotModal(true);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible1(true);
  };
  const handleDelete = () => {
    const updatedData = data.filter((item) => item.id !== selectedItem.id);
    setData(updatedData);
    setModalvisible1(false);
    setSelectedItem(null);
  };

  return (
    <SafeAreaView style={Appstyles.safe}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={Appstyles.ArrowImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>Holidays</Text>
        </View>
        <View style={styles.ImagesView}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => navigation.navigate("AddHolidays")}>
            <Image
              source={AppImages.Plus}
              style={Appstyles.PlusImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ marginTop: 20, backgroundColor: "white", flex: 1 }}>
        <View style={{ marginHorizontal: 20 }}>
          <View style={{ marginTop: 20, marginBottom: 20 }}>
            <View style={Appstyles.cateee7}>
              <View style={Appstyles.Searchvii6}>
                <TextInput
                  style={Appstyles.TextInput7}
                  placeholder="Search..."
                  placeholderTextColor={"#AAAAAA"}
                  editable={true}
                  value={searchText} // Bind search input value to state
                  onChangeText={handleSearch}
                />

                <View
                  style={{
                    alignItems: "flex-end",

                    justifyContent: "center",

                    flex: 1,
                  }}
                >
                  <Image
                    source={AppImages.search}
                    style={{ width: 20, height: 20, marginRight: 20 }}
                  />
                </View>
              </View>
            </View>
          </View>
          <FlatList
            showsVerticalScrollIndicator={false}
            ListFooterComponent={() => <View style={{ padding: 45 }} />}
            data={data}
            renderItem={({ item }) => (
              <View
                style={{
                  marginBottom: 20,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: AppColors.sandal,
                  borderRadius: 10,
                  // borderTopLeftRadius:15,
                  // borderBottomLeftRadius:15,
                  borderColor: AppColors.sandal,
                  borderWidth: 0.5,
                }}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      backgroundColor: AppColors.white,
                      width: 100,
                      height: 100,
                      justifyContent: "center",
                      borderColor: AppColors.sandal,
                      borderWidth: 0.5,
                      borderRadius: 11,
                      shadowColor: "#9C4900",
                      shadowOffset: { width: 10, height: 10 },
                      shadowOpacity: 10,
                      shadowRadius: 11,
                      elevation: 4,

                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 16,

                        fontFamily: AppFonts.OverpassSemiBold,
                        color: AppColors.brown1,
                      }}
                    >
                      {item.Day}
                    </Text>
                    <Text
                      style={{
                        fontSize: 16,

                        fontFamily: AppFonts.OverpassSemiBold,
                        color: AppColors.brown1,
                      }}
                    >
                      {item.Month}
                    </Text>
                  </View>
                  <View
                    style={{
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,

                        fontFamily: AppFonts.OverpassSemiBold,
                        color: AppColors.brown1,
                      }}
                    >
                      {item.NewYear}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,

                        fontFamily: AppFonts.OverpassMedium,
                        color: AppColors.dualbrown,
                      }}
                    >
                      {item.Friday}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,

                        fontFamily: AppFonts.OverpassBold,
                        color: AppColors.brown1,
                      }}
                    >
                      {item.Active}
                    </Text>
                  </View>
                </View>
                <TouchableOpacity onPress={() => handleThreeDotPress(item)}>
                  <Image
                    source={AppImages.Threedots}
                    style={{
                      width: 22,
                      height: 22,
                      alignItems: "center",
                      marginRight: 10,
                    }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              </View>
            )}
          />
        </View>
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
          <View style={styles.feed}></View>
        </TouchableWithoutFeedback>
        <View style={styles.viww}>
          <TouchableOpacity style={styles.hsh}>
            <Image source={AppImages.LineBar} style={styles.jns} />
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              marginTop: 10,

              flexDirection: "row",
            }}
            onPress={() => [
              setDotModal(false),
              navigation.navigate("EditHolidays"),
            ]}
          >
            <View style={styles.yooo}>
              <Text style={styles.modo}>Edit</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.fffsf}
            onPress={handleDeleteConfirmation}
          >
            <View style={styles.yooo}>
              <Text style={styles.ttxt}>Delete</Text>
            </View>
          </TouchableOpacity>
        </View>
      </Modal>

      {/* //-----------DeleteModal------// */}

      <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1);
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(false)}
          style={styles.presse}
        >
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>Vehicle</Text>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setModalvisible1(false);
                }}
              >
                <Image
                  source={AppImages.cross}
                  style={styles.hhsj}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>

            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsds}>
                Are you sure you want to delete this Holiday ?
              </Text>
            </View>

            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModalDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity
                        onPress={() => [
                          handleDelete(),
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity onPress={() => setModalvisible1(false)}>
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </SafeAreaView>
  );
};

export default Holidays;

const styles = StyleSheet.create({
  HeaderMain: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: "#9C4900",
    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 20,
  },
  HeaderSec: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  HeaderBackTouch: { height: 30, width: 30, justifyContent: "center" },
  HeaderBackImage: { width: 8, height: 15 },
  ImagesView: {
    flexDirection: "row",
    alignItems: "center",
  },
  img: { width: 16, height: 20 },
  imgg: { width: 18, height: 18, marginLeft: 20 },
  HeadTextVechicle: {
    color: "#8F4300",
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 16,
  },

  feed: { backgroundColor: AppColors.ModalColor, flex: 1 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: 2,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.dualbrown,
  },
  fffsf: {
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12, alignItems: "center" },
  fasfd: { marginTop: 10, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  lins: {
    borderTopWidth: 1,
    width: "100%",
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 10,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
});
